import React, { useMemo } from "react";
import { StreamingProvider } from "@switcherstudio/switcher-api-client";
import styles from "../index.module.scss";
import SwitcherLogo from "assets/SwitcherPlayerIconGradient.svg";
import { useClaimCheck } from "hooks/useClaimCheck";
import { PlatformId } from "views/page-content/platforms/types";
import { PlatformIcon } from "components/icons/PlatformIcon";

export const DestinationCard = ({
    platform,
    isDisabled = false,
    clickHandler
}: {
    platform?: StreamingProvider;
    isDisabled?: boolean;
    clickHandler: () => void;
}) => {
    const hasCatalogClaim = useClaimCheck("catalog");
    const id = platform.Id;
    const name = useMemo<string>(() => {
        if (id === PlatformId.VideoPlayer) {
            if (hasCatalogClaim) {
                return "Video Catalog";
            } else {
                return "Switcher Player";
            }
        } else if (id === PlatformId.AmazonLive) {
            return "Amazon Live";
        } else if (id === PlatformId.Caast) {
            return "Caast";
        } else if (id === PlatformId.Instafeed) {
            return "Instafeed";
        } else if (id === PlatformId.MsStream) {
            return "Microsoft Stream";
        }

        return platform.Name;
    }, [hasCatalogClaim, platform, id]);

    const icons = {
        facebook: (
            <PlatformIcon
                destination="FaceBookSwitcherStreamSetting"
                platformId={PlatformId.Facebook}
                useNewIcon={true}
            />
        ),
        youtube: (
            <PlatformIcon
                destination="YouTubeSwitcherStreamSetting"
                platformId={PlatformId.Youtube}
                useNewIcon={true}
            />
        ),
        twitch: (
            <PlatformIcon
                destination="TwitchSwitcherStreamSetting"
                platformId={PlatformId.Twitch}
                useNewIcon={true}
            />
        ),
        custom: <PlatformIcon destination="custom" useNewIcon={true} />,
        switcherplayer: <img src={SwitcherLogo} alt="Switcher logo" />
    };

    return (
        <div
            className={`${styles["destination-card"]} ${
                isDisabled ? styles["is-greyed"] : ""
            } ${isDisabled ? styles["is-disabled"] : ""}`}
            onClick={clickHandler}
        >
            <span className={styles["icon-container"]}>
                {platform?.LogoUrl ? (
                    <img alt="platform logo" src={platform?.LogoUrl} />
                ) : (
                    icons[id]
                )}
            </span>
            <div className={styles["platform-name"]}>{name}</div>
        </div>
    );
};
